export const NET_PRICE_ADJUSTMENT = 5;
